import { alpha, makeStyles, Theme } from '@material-ui/core/styles';

const SOFT_ALPHA = 0.08;
const BORDER_ALPHA = 0.42;
const RING_ALPHA = 0.14;

export const useDraftStyles = makeStyles((theme: Theme) => ({
    '@keyframes callPulse': {
        '0%, 100%': { opacity: 0.35, transform: 'scale(0.84)' },
        '50%': { opacity: 1, transform: 'scale(1)' },
    },
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'grid',
        flexBasis: '100%',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
        paddingTop: theme.spacing(1.5),
        width: '100%',
    },
    titleRow: { alignItems: 'center', display: 'flex', gap: theme.spacing(1) },
    actionIcon: {
        alignItems: 'center',
        backgroundColor: 'var(--action-soft-color)',
        borderRadius: theme.shape.borderRadius,
        color: 'var(--action-color)',
        display: 'inline-flex',
        height: 30,
        justifyContent: 'center',
        width: 30,
    },
    actionButton: {
        backgroundColor: 'var(--action-color)',
        color: theme.palette.common.white,
        '&:hover': { backgroundColor: 'var(--action-hover-color)' },
    },
    fileArea: {
        alignItems: 'center',
        border: `1px dashed ${alpha(theme.palette.primary.main, BORDER_ALPHA)}`,
        borderRadius: theme.shape.borderRadius * 2,
        color: theme.palette.primary.main,
        cursor: 'pointer',
        display: 'flex',
        gap: theme.spacing(1.25),
        padding: theme.spacing(1.5),
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, SOFT_ALPHA),
        },
    },
    callProgress: {
        alignItems: 'center',
        backgroundColor: alpha(theme.palette.primary.main, SOFT_ALPHA),
        border: `1px solid ${alpha(theme.palette.primary.main, BORDER_ALPHA)}`,
        borderRadius: theme.shape.borderRadius * 2,
        display: 'flex',
        gap: theme.spacing(1.75),
        padding: theme.spacing(2),
    },
    callPulse: {
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 0 0 7px ${alpha(theme.palette.primary.main, RING_ALPHA)}`,
        color: theme.palette.primary.contrastText,
    },
    callWave: { alignItems: 'center', display: 'flex', gap: 3, marginTop: 9 },
    callWaveBar: {
        animation: '$callPulse 900ms ease-in-out infinite',
        backgroundColor: theme.palette.secondary.main,
        borderRadius: 999,
        height: 12,
        width: 4,
        '&:nth-child(2)': { animationDelay: '120ms', height: 19 },
        '&:nth-child(3)': { animationDelay: '240ms', height: 15 },
        '&:nth-child(4)': { animationDelay: '360ms', height: 22 },
        '&:nth-child(5)': { animationDelay: '480ms', height: 13 },
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    },
}));
